export default __webpack_public_path__ + "static/media/background-compartilhado.7aab4f34.svg";